import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { CollaboratorModel } from '../../../models/configuration/company/collaborator.model';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';

export class GetProfesionalByCompanyidUseCase
  implements UseCase<
    { idSedeEmpresa: string; idServicioEmpresa: string },
    CollaboratorModel
  >
{
  constructor(private configurationRepository: ConfigurationRepository) {}

  execute(params: {
    idSedeEmpresa: string;
    idServicioEmpresa: string;
  }): Observable<CollaboratorModel> {
    return this.configurationRepository.getProfesionalByCompanyid(params);
  }
}